<template>
    <div>
        <div class="type-item" v-if="bizType==-1 || bizType==1" @click="goto(20, 10)">
            <div class="type-img">
                <img src="/static/gt-1.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">出售闲置书籍</div>
                    <div class="info">(￣o￣) . z Z</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==2" @click="goto(10, 10)">
            <div class="type-img">
                <img src="/static/gt-2.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">想省钱买书</div>
                    <div class="info">╮（╯＿╰）╭</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==1" @click="goto(20, -1)">
            <div class="type-img">
                <img src="/static/gt-3.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">出售闲置物品</div>
                    <div class="info">Ｏ(≧口≦)Ｏ</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==2" @click="goto(10, -1)">
            <div class="type-img">
                <img src="/static/gt-4.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">想省钱买</div>
                    <div class="info">ο(=•ω＜=)ρ⌒☆</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==3" @click="goto(30, -1)">
            <div class="type-img">
                <img src="/static/gt-5.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">想租物品</div>
                    <div class="info">o(一︿一+)o</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==3" @click="goto(40, -1)">
            <div class="type-img">
                <img src="/static/gt-6.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">出租闲置物品</div>
                    <div class="info">Ψ(￣∀￣)Ψ</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==3" @click="goto(50, -1)">
            <div class="type-img">
                <img src="/static/gt-7.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">想借物品</div>
                    <div class="info">○|￣|_</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1 || bizType==3" @click="goto(60, -1)">
            <div class="type-img">
                <img src="/static/gt-8.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">出借闲置物品</div>
                    <div class="info">[]~(￣▽￣)~*</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
        <div class="type-item" v-if="bizType==-1" @click="goto(70, -1)">
            <div class="type-img">
                <img src="/static/gt-9.png">
            </div>
            <div class="type-desc">
                <div>
                    <div class="title">技能服务</div>
                    <div class="info">手工技术、考试面试、陪聊散心o(*≧▽≦)ツ</div>
                </div>
            </div>
            <div class="type-go">
                <i class="iconfont icon-jiantou"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            encodeToken: "",
            bizType: -1
        }
    },
    created() {
        this.encodeToken = this.$route.params.token;
        this.bizType = this.$route.params.bizType;
    },
    methods: {
        goto(bizType, goodsType) {
            this.$router.push("/circleEdit/"+bizType+"/"+goodsType+"/-1/"+this.encodeToken);
        }
    }
}
</script>

<style scoped>
.type-item {
    display: flex;
    border-bottom: 1px solid #bdccd4;
}
.type-img {
    width: 100px;
    height: 80px;
    margin-left: 10px;
    display: flex;
    align-items:center;
    justify-content:center;
}
.type-desc {
    flex: 1;
    display: flex;
    align-items:center;
    color: #6b6e77;
}
.type-desc .title {
    font-size: 16px;
    font-weight: bold;
}
.type-desc .info {
    padding-top: 5px;
}
.type-go {
    width: 40px;
    display: flex;
    align-items:center;
    justify-content:center;
}
.type-img img {
    width: 80px;
    height: 80px;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/CircleType.vue